import PageTemplate from "./PageTemplate";
import {connect} from "redux-vue";

const HomePage = {
  props: ['user'],

  /**
   * 
   * @param h
   * @returns {*}
   */
  render(h) {
    const isAuthorized = !!(this.user.token && this.user.model);
    
    return (
      <PageTemplate>
        <div class="bg-white relative">
          <div class="container lg:px-6 mx-auto overflow-x-hidden lg:overflow-x-visible">
            <div class="flex flex-wrap w-full">
              <div class="order-2 lg:order-1 lg:w-7/12 lg:py-10 p-6 lg:px-0">
                <h1 class="text-2xl lg:text-5xl lg:w-11/12 leading-tight mb-5">
                  <span class="text-2xl lg:text-3xl text-gray-400 block">
                    {this.$t('home_page.welcome')}
                  </span>
                  <span class="font-bold">
                    {this.$t('home_page.h1')}
                  </span>
                </h1>
                <p class="lg:w-11/12">
                  {this.$t('home_page.line_1')}
                  <br/><br/>
                  {this.$t('home_page.line_2')}
                </p>
              </div>
              <div
                class="order-1 lg:order-2 lg:w-5/12 bg-cover bg-center lg:absolute lg:top-0 lg:bottom-0 lg:left-auto lg:right-0"
                style="background-image: url('/img/hero-home.jpg')">
                <div class="lg:hidden h-40 w-screen"></div>
                <div class="lg:hidden h-40 w-screen"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="bg-secondary">
          <div class="container mx-auto">
            <div class="lg:w-10/12 xl:w-8/12 mx-auto py-10">
              <div class="flex flex-wrap">
                <div class="lg:w-1/2 p-4">
                  <div class="bg-white shadow rounded p-5 pb-10 h-full">
                    <div class="flex flex-col items-center justify-between h-full">
                      <div class="text-center">
                        <i class="mdi mdi-school text-green-400 leading-none" style="font-size: 3rem;"></i>
                        <p class="text-xs text-gray-500 my-3">
                          {this.$t('home_page.enroll_master.small')}
                        </p>
                        <h3 class="text-2xl">
                          {this.$t('home_page.enroll_master.h3')}
                        </h3>
                        <p class="text-base text-gray-600 mt-5 mb-10">
                          {this.$t('home_page.enroll_master.p')}
                        </p>
                      </div>
                      <router-link
                        class="px-5 p-2 rounded-full bg-action hover:bg-action-dark focus:outline-none focus:shadow-outline text-lg text-white"
                        to={{name: 'CoursesPage'}}>
                        {this.$t('explore_courses')}
                        <i class="mdi mdi-arrow-right ml-5"></i>
                      </router-link>
                    </div>
                  </div>
                </div>
                <div class="lg:w-1/2 p-4">
                  <div class="bg-white shadow rounded p-5 pb-10 h-full">
                    <div class="flex flex-col items-center justify-between h-full">
                      <div class="text-center">
                        <i class="mdi mdi-cursor-default text-blue-500 hover:underline leading-none" style="font-size: 3rem;"></i>
                        <p class="text-xs text-gray-500 my-3">
                          {this.$t('home_page.enroll_course.small')}
                        </p>
                        <h3 class="text-2xl">
                          {this.$t('home_page.enroll_course.h3')}
                        </h3>
                        <p class="text-base text-gray-600 mt-5 mb-10">
                          {this.$t('home_page.enroll_course.p')}
                        </p>
                      </div>
                      <router-link
                        class="px-5 p-2 rounded-full bg-action hover:bg-action-dark focus:outline-none focus:shadow-outline text-lg text-white"
                        to={{name: 'CoursesPage'}}>
                        {this.$t('explore_courses')}
                        <i class="mdi mdi-arrow-right ml-5"></i>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {isAuthorized || (
          <div class="bg-white">
            <div class="container mx-auto">
              <div class="px-6 lg:px-0 pt-10 text-center">
                <h3 class="text-2xl font-bold">
                  {this.$t('home_page.h3')}
                </h3>
                <div class="flex flex-col lg:flex-row items-center justify-center py-10">
                  <router-link
                    class="px-5 p-2 rounded-full bg-action hover:bg-action-dark focus:outline-none focus:shadow-outline text-xl text-white"
                    to={{name: 'RegisterModal'}}>
                    {this.$t('create_an_account')}
                    <i class="mdi mdi-arrow-right ml-5"></i>
                  </router-link>
                  <div class="pt-6 lg:pt-0 lg:ml-8">
                    {this.$t('existing_user')}{' '}
                    <router-link to={{name: 'LoginModal'}} class="text-blue-500 hover:underline">
                      {this.$t('log_in')}
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </PageTemplate>
    );
  }
};

function mapStateToProps(state) {
  return {
    user: state.user
  };
}

function mapActionToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapActionToProps)(HomePage);